import { useEffect } from 'react';
import { useSistemaQuery } from '@/features/sistema/api';
import { setColorFromLayout } from '@/features/sistema/util';
import { changeFavIcon } from '@/std/util';

export function useAppSistema() {
    const { sistema } = useSistemaQuery();

    useEffect(() => {
        if (sistema) {
            changeFavIcon(sistema.sis_logotipo || '');
            setColorFromLayout(sistema.layout);
        }
    }, [sistema]);
}
